import React from "react";

const SecuritySettings = ({ settings, handleChange }) => {
  return (
    <div>
      <h3 className="text-lg font-medium mb-4">Security Settings</h3>
      
      {/* <div className="flex items-center mb-4">
        <input
          id="twoFactor"
          type="checkbox"
          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          checked={settings.security.enableTwoFactor}
          onChange={(e) => handleChange("security", "enableTwoFactor", e.target.checked)}
        />
        <label htmlFor="twoFactor" className="ml-2 block text-sm">
          Enable Two-Factor Authentication
        </label>
      </div> */}
      {/* <p className="text-xs text-gray-500 mb-4 italic">
        Note: Two-factor authentication settings will be saved via backend API integration (not implemented in this demo).
      </p> */}
      
      <div className="mb-4">
        <div className="mb-2">
          <label htmlFor="passwordOptions" className="block text-sm font-medium text-gray-700 mb-1">
            Password Options
          </label>
          <select
            id="passwordOptions"
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            value={settings.security.changePassword ? "change" : "keep"}
            onChange={(e) => handleChange("security", "changePassword", e.target.value === "change")}
          >
            <option value="keep">Keep Current Password</option>
            <option value="change">Change Password</option>
          </select>
        </div>
        
        {settings.security.changePassword && (
          <div className="mt-3 pl-6 border-l-2 border-gray-200">
            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">Current Password</label>
              <input 
                type="password"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                value={settings.security.currentPassword}
                onChange={(e) => handleChange("security", "currentPassword", e.target.value)}
              />
            </div>
            
            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
              <input 
                type="password"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                value={settings.security.newPassword}
                onChange={(e) => handleChange("security", "newPassword", e.target.value)}
              />
            </div>
            
            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-700 mb-1">Confirm New Password</label>
              <input 
                type="password"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                value={settings.security.confirmPassword}
                onChange={(e) => handleChange("security", "confirmPassword", e.target.value)}
              />
            </div>
            
            {settings.security.newPassword && 
             settings.security.confirmPassword && 
             settings.security.newPassword !== settings.security.confirmPassword && (
              <div className="text-red-500 text-sm mb-3">
                Passwords do not match
              </div>
            )}
            
            {/* <p className="text-xs text-gray-500 mt-2 italic">
              Note: Password change functionality requires backend API integration (not implemented in this demo).
            </p> */}
          </div>
        )}
      </div>
      
      <div className="mt-6 p-3 bg-yellow-50 border border-yellow-100 rounded-md">
        <h4 className="text-sm font-medium text-yellow-800 mb-1">Security Tips</h4>
        <ul className="text-xs text-yellow-700 list-disc pl-4">
          <li className="mb-1">Use a strong, unique password for your account</li>
          
          <li className="mb-1">Never share your password with anyone</li>
          <li>Log out when using public computers</li>
        </ul>
      </div>
    </div>
  );
};

export default SecuritySettings; 